// add content controll
export const createContentControl = async (serviceTag, serviceName) => {
  return Word.run(async context => {
    // Xóa nếu đã tồn tại
    // const exingtiServiceNameContentControl = context.document.contentControls.getByTag(serviceTag).getFirst();
    // exingtiServiceNameContentControl.clear();

    // Sau đó thêm mới

    const serviceNameRange = context.document.getSelection();
    const serviceNameContentControl = serviceNameRange.insertContentControl();
    serviceNameContentControl.title = serviceName;
    serviceNameContentControl.tag = serviceTag;
    serviceNameContentControl.appearance = "BoundingBox";
    serviceNameContentControl.color = "blue";
    serviceNameContentControl.font.color = "red";
    serviceNameContentControl.insertText(
      'Cập nhập nội dung cho "' + serviceName + '"',
      "Replace"
    );
    serviceNameContentControl.cannotEdit = true;
    serviceNameContentControl.cannotDelete = true;
    await context.sync();
  });
};

// Update content by code
export const updateContentControl = async (
  serviceTag,
  textReplace = "Đoạn văn bản đã được ký & sửa",
  mode = "Replace"
) => {
  return Word.run(async context => {
    const serviceNameContentControl = context.document.contentControls
      .getByTag(serviceTag)
      .getFirst();
    serviceNameContentControl.cannotEdit = false;
    serviceNameContentControl.insertText(textReplace, mode);
    serviceNameContentControl.cannotEdit = true;

    await context.sync();
  });
};

// unlock content by code
export const unlockContentControl = serviceTag => {
  serviceTag = serviceTag || id;
  Word.run(async context => {
    const serviceNameContentControl = context.document.contentControls
      .getByTag(serviceTag)
      .getFirst();
    serviceNameContentControl.cannotEdit = false;
    // serviceNameContentControl.insertText("Đoạn văn bản đã được ký & sửa 2", "Replace");
    // serviceNameContentControl.cannotEdit = true;

    await context.sync();
  });
};
export const lockContentControl = async serviceTag => {
  serviceTag = serviceTag || id;
  return Word.run(async context => {
    const serviceNameContentControl = context.document.contentControls
      .getByTag(serviceTag)
      .getFirst();
    serviceNameContentControl.cannotEdit = true;

    await context.sync();
  });
};
